import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  targetId: string;
  children: React.ReactNode;
}

// This component renders the children component into a different part of the DOM using React Portal.
export const Portal = ({ targetId, children }: PortalProps) => {
  const [targetNode, setTargetNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setTargetNode(document.querySelector<HTMLElement>(`#${targetId}`));
  }, [targetId]);

  if (!targetNode) {
    return null;
  }

  return createPortal(children, targetNode);
};
